import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { Toggle } from "@app/shared/Toggle"
import { FC } from "react";

interface ShowFullDataToggleProps {
    label: string;
    tooltipText: string;
    active: boolean;
    onChange: () => void;
    testId: string;
}

export const ShowFullDataToggle: FC<ShowFullDataToggleProps> = ({ label, tooltipText, active, onChange, testId }: ShowFullDataToggleProps) => (
    <Toggle
        label={
            <div className="provider-hub-full-data-toggle">
                {label}
                <TooltipWrapper
                    text={
                        <div className="provider-hub__filter_definitions-tooltip">
                            <p>{tooltipText}</p>
                        </div>
                    }
                    position="top"
                    tooltipWidth="13%"
                    style={{wordWrap: 'break-word'}}
                >
                    <QesIcon iconName={QesIcons.InfoCircle} isDecorative />
                </TooltipWrapper>
            </div>
        }
        testId={testId}
        active={active}
        onChange={onChange}
    />
);